import { MainReducer } from '@/entities/cart';

import { LoadingReducer } from '@/shared/services/loading';

import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
  main: MainReducer,
  loading: LoadingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production' && {
    name: 'Cart Redux FSD',
  },
});

export default store;

export type CartRootState = ReturnType<typeof store.getState>;
export type CartAppDispatch = typeof store.dispatch;
export type CartAppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  CartRootState,
  unknown,
  Action<string>
>;
